export default "__VITE_ASSET__2617f6d1__"